/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from "react-intl";
import {ReplacePhone} from "@utils/index";

type Props = {
    text: string
    translate?: boolean
}

const PhoneClient: FC<Props> = ({text}) => {
    return (
        <div className='fs-6 text-gray-600 fw-semibold'>
            {ReplacePhone(text||'')}
        </div>
    )
}

export {PhoneClient}
